const pl = {
    path: '/pl',
    name: 'Polish',
    shorthand: 'pl',
}
exports.pl = pl

